const creditCardErrorMessagesMap: Record<string, string> = {
  'Insufficient funds': 'Your card was declined due to insufficient funds',
  'Exceeds withdrawal frequency': 'Your card exceeded withdrawal frequency, please try again later',
  'Do not honor': 'Payment unsuccessful, please try again',
  'Soft Decline - Authentication is Advised': 'Your card was declined, please try again',
  'Transaction not permitted to cardholder': 'Invalid cardholder name, please try again',
  'Format error': 'Your card was declined, please try another payment method',
  'Invalid transaction': 'Your card was declined, please try another payment method',
  'Timeout/Retry': 'Payment unsuccessful, please try again',
  'Suspected fraud': 'Your card was declined, please try again',
  'Exceeds withdrawal limit': 'Your card exceeded withdrawal limit, please try again later',
  'Restricted card': 'Your card was declined, please try another payment method',
  'Transaction not permitted on terminal':
    'Your card was declined, please try another payment method',
  'Security violation': 'Payment unsuccessful, please try again',
  'Invalid Card Number': 'Invalid card number, please try another payment method',
  'Not Allowed to Process this Auth Type': 'Payment unsuccessful, please try again',
  'Expired card': 'Card is expired, please try another payment method',
  'Closed account by issuer. Issuer will not approve same amount in next 30 days':
    'Card account is closed, please try another payment method',
  'Blocked, first used-transaction from new cardholder, and card not properly unblocked':
    'New card was not unblocked, contact your card issuer',
  'Auth Code/Trans ID/Credit Card Number Mismatch': 'Invalid card details, please try again',
  'Closed account': 'Card account is closed, please try another payment method',
  'System Error': 'Payment unsuccessful, please try again',
  'Invalid transaction; contact card issuer': 'Payment unsuccessful, please try again',
  'Pick-up card': 'Your card was declined, please try another payment method',
  'Closed account.': 'Card account is closed, please try another payment method',
  'UNEXPECTED SYSTEM ERROR - PLEASE RETRY LATER': 'Payment unsuccessful, please try again',
  'Invalid Currency': 'Currency not supported, please try another payment method',
  'Lost card, pick-up': 'Your card was declined, please try another payment method',
  'Transaction cannot be completed; violation of law':
    'Your card was declined, please try another payment method',
  'Duplicated transaction. Try later': 'Your card was declined, please try another payment method',
  'Unrecognized credit card company':
    'Credit card type not supported, please try another payment method',
  'Transaction already settled': 'Payment unsuccessful, please try again',
  'Issuer or switch inoperative':
    'Credit card type not supported, please try another payment method',
  'Issuer data is not available, please try again later': 'Payment unsuccessful, please try again',
  'Invalid merchant': 'Your card was declined, please try another payment method',
  'Not allowed to process this CC company':
    'Credit card type not supported, please try another payment method',
  'Negative CAM, dCVV, iCVV, or CVV results': 'Payment unsuccessful, please try again',
  'Stolen card, pick-up': 'Your card was declined, please try another payment method',
  'No current account': 'Card account is closed, please try another payment method',
  'Invalid account specified': 'Invalid card account, please try another payment method',
  'Invalid Card Number (MOD 10)': 'Invalid card number, please try again',
  'Invalid Card Number (Digits Count)': 'Invalid card number, please try again',
  'Invalid amount': 'Payment unsuccessful, please try again',
  "Invalid 'To' account specified": 'Payment unsuccessful, please try again',
  'Invalid Issue Number': 'Payment unsuccessful, please try again',
  'Call issuer': 'Payment unsuccessful, please try again',
  'Invalid CVV2': 'Invalid CVV2, please try again',
  'Suspected fraud by issuer. Issuer will not approve same amount in the next 30 days':
    'Your card was declined, please try another payment method',
  Decline: 'Payment unsuccessful, please try again',
  'Pick up card, special condition (fraud account)':
    'Your card was declined, please try another payment method',
  'TRANSID=1130000003582422865 TRANSREC=D TRANSSCORE=0TRANSREASONAMOUNT=1 TRANSREASON1=1007008895':
    'Payment unsuccessful, please try again',
  'Verification data failed': 'Payment unsuccessful, please try again',
  'No checking account': 'Card account is closed, please try another payment method',
  'No savings account': 'Card account is closed, please try another payment method',
  'No credit account': 'Card account is closed, please try another payment method',
  'Lost/Stolen': 'Your card was declined, please try again',
  'No such issuer': 'Your card was declined, please try another payment method',
  'Unable to locate record in file': 'Payment unsuccessful, please try again',
  'File temporarily not available': 'Payment unsuccessful, please try again',
  'External Error in Processing': 'Payment unsuccessful, please try again',
  'Routing error': 'Payment unsuccessful, please try again',
  'Transaction cannot be completed': 'Payment unsuccessful, please try again',
  'System not available': 'Payment unsuccessful, please try again',
  'Revocation of Authorization Order': 'Payment unsuccessful, please try again',
  'Duplicate transaction': 'Your card was declined, please try another payment method',
};

export const DEFAULT_ERROR_MESSAGE = 'Payment unsuccessful, please try again';

export function getNuveiUserReadbleErrorMessage(nuveiErrorMessage: string) {
  const errorMessage = creditCardErrorMessagesMap[nuveiErrorMessage];
  return errorMessage || DEFAULT_ERROR_MESSAGE;
}
